import { SxStyleProp } from 'theme-ui';
import theme from '../../gatsby-plugin-theme-ui';

export const TextContainer: SxStyleProp = {
  a: {
    color: theme.colors?.lavender[100],
    fontWeight: 900,
    textDecoration: 'none',
    transition: `color ${theme.transition.duration}`,

    '&:hover': {
      color: theme.colors?.black[100],
    },
  },
  p: { margin: 'revert' },
  variant: 'text.body1',
  h1: { variant: 'text.h1Bold' },
  h2: { variant: 'text.h2' },
  h3: { variant: 'text.h3' },
  h4: { variant: 'text.h4' },
  h5: { variant: 'text.h5' },
  '.gatsby-image-wrapper': {
    width: '100% !important',
  },
  figure: {
    m: 0,
    '> img': {
      width: '100%',
      height: 'unset',
    },
  },
  img: {
    height: 'auto',
    maxWidth: '100%',

    '&.alignright': {
      float: 'right',
    },
    '&.alignleft': {
      float: 'left',
    },
    '&.aligncenter': {
      display: 'block',
      margin: '0 auto',
    },
  },
  'ul > li': {
    listStyle: 'none',
    ml: '25px',
    position: 'relative',
    '&::before': {
      content: '""',
      border: '8px solid transparent',
      borderLeftColor: 'lavender.100',
      display: 'inline-block',
      position: 'absolute',
      left: '-20px',
      top: '12px',
      marginTop: '-8px',
    },
  },
  table: {
    border: '2px solid #9fbad6',
    display: 'inline-block',
    margin: '0 auto',
    maxWidth: '100%',
    overflow: 'auto',
    thead: {
      backgroundColor: '#3c3d78',
      color: 'white',
    },
    'td, th': {
      padding: '10px 16px',
      textAlign: 'center',
    },
    'tbody tr': {
      backgroundColor: '#d5e3fa',
      '&:nth-of-type(odd)': {
        backgroundColor: '#edf5fe',
      },
      '&:last-of-type': {
        fontWeight: 900,
      },
    },
  },
};
